import './list.scss';
